<template>
  <div class="app" :class="{ 'operation-default': themeCode === 'default', 'operation': themeCode === 'blue' }">
    <div class="energy-content-r-top">
      <div>
        <DatePicker v-model="times" format="yyyy-MM-dd" type="daterange" placement="bottom-end" :placeholder="$t('operation_log.operation.506627-0')"
          style="width: 10vw"></DatePicker>
      </div>
      <div>
        <Input v-model="loginCode" clearable :placeholder="$t('operation_log.operation.506627-1')"></Input>
      </div>
      <div>
        <Input v-model="deviceCode" clearable :placeholder="$t('operation_log.operation.506627-2')"></Input>
      </div>
      <div>
        <Input v-model="userDeviceName" clearable :placeholder="$t('operation_log.operation.506627-3')"></Input>
      </div>
      <div>
        <Button type="primary" @click="inquireClick">{{ $t('operation_log.operation.506627-4') }}</Button>
      </div>
      <div>
        <Button type="success" @click="exportClick">{{ $t('operation_log.operation.506627-5') }}</Button>
      </div>
    </div>
    <div class="energy-content-r-content">
      <dv-border-box-10 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']"
        :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
        <div class="energy-ranking">
          <div class="map-bottom-content-tab">
            <div class="map-bottom-content-tab-item">{{ $t('operation_log.operation.506627-1') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('operation_log.operation.506627-6') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('operation_log.operation.506627-3') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('operation_log.operation.506627-2') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('operation_log.operation.506627-7') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('operation_log.operation.506627-8') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('operation_log.operation.506627-9') }}</div>
          </div>
          <div class="map-bottom-list">
            <div class="map-bottom-lists" v-if="DeviceOperateLists.length > 0">
              <div class="map-bottom-list-item" v-for="(item) in DeviceOperateLists" :key="item.Id">
                <div class="map-bottom-list-item-device">{{ item.MobilePhone }}</div>
                <div class="map-bottom-list-item-device">{{ item.UserName }}</div>
                <div class="map-bottom-list-item-addr">{{ item.UserDeviceName }}</div>
                <div class="map-bottom-list-item-date">{{ item.DeviceCode }}</div>
                <div class="map-bottom-list-item-date">{{ item.Remark }}</div>
                <div class="map-bottom-list-item-device">{{ item.DeviceOperateResultName }}</div>
                <div class="map-bottom-list-item-device">{{ item.CreateTime }}</div>
              </div>
            </div>
            <div v-else class="map-right-group-list-none">{{ $t('operation_log.operation.506627-10') }}</div>
          </div>
          <div class="user-top-list-page">
            <Page :total="TotalCount" :current="pageIndex" :page-size="pageSize" @on-change="DeviceChange"
              @on-page-size-change="DeviceSizeChange" size="small" show-elevator show-sizer placement="top" show-total />
          </div>
        </div>
      </dv-border-box-10>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import api from '../../../api/request.js'
export default {
  data() {
    return {
      times: [],
      deviceCode: '',
      userDeviceName: '',
      loginCode: '',
      pageIndex: 1,
      pageSize: 20,
      DeviceOperateLists: [],
      TotalCount: 0,
      themeCode: '',

    }
  },

  created() {
    let _this = this;
    _this.themeCode = _this.$store.getters.getThemeCode;
  },

  computed: {

  },

  filters: {
    initDate(value) {
      if (!value) return '';
      let list = value.split(' ');
      return list[0];
    },
  },

  mounted() {
    let _this = this;
    // 获取当天时间
    _this.getTiemDate();
    // 获取用户设备操作日志
    _this.GetUserDeviceOperate();
  },

  methods: {
    // 获取当天时间
    getTiemDate() {
      let _this = this;
      var date = new Date();
      date.setMonth(date.getMonth() - 1);
      var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

      var dates = new Date();
      var dateStrings = dates.getFullYear() + "-" + (dates.getMonth() + 1) + "-" + dates.getDate();

      _this.times = [dateString, dateStrings];
    },
    // 获取用户设备操作日志
    GetUserDeviceOperate() {
      if (!Cookies.get('AdminData')) {
        if (window.location.host == 'xed.hxpwr.com') {
          this.$router.push({
            name: 'xed_login'
          })
        } else {
          this.$router.push({
            name: 'login'
          })
        }
        return;
      }
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData')),
        startDt = '',
        endDt = '';

      if (_this.times.length > 0) {
        startDt = _this.formDate(_this.times[0]);
        endDt = _this.formDate(_this.times[1])
      };
      _this.$store.dispatch("setEnergyState", true);
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetUserDeviceOperate?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}&loginCode=${_this.loginCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.$store.dispatch("setEnergyState", false);
        if (res.Success) {
          _this.DeviceOperateLists = res.Data;
          _this.TotalCount = res.TotalCount;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    DeviceChange(value) {
      let _this = this;
      _this.pageIndex = value;
      _this.GetUserDeviceOperate();
    },
    DeviceSizeChange(value) {
      let _this = this;
      _this.pageIndex = 1;
      _this.pageSize = value;
      _this.GetUserDeviceOperate();
    },
    // 搜索
    inquireClick() {
      let _this = this;
      _this.pageIndex = 1;
      _this.GetUserDeviceOperate();
    },
    // 导出
    exportClick() {
      let _this = this;
      if (!Cookies.get('AdminData')) {
        if (window.location.host == 'xed.hxpwr.com') {
          this.$router.push({
            name: 'xed_login'
          })
        } else {
          this.$router.push({
            name: 'login'
          })
        }
        return;
      }
      let AdminData = JSON.parse(Cookies.get('AdminData')),
        startDt = '',
        endDt = '';

      if (_this.times.length > 0) {
        startDt = _this.formDate(_this.times[0]);
        endDt = _this.formDate(_this.times[1])
      };
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/Export_UserDeviceOperate?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}&loginCode=${_this.loginCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          window.location.href = res.Data;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 时间转换
    formDate(dateForm) {
      if (!dateForm) {
        return "";
      } else {
        var dateee = new Date(dateForm).toJSON();
        var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
          /\.[\d]{3}Z/, '');
        return date;
      }
    },

  }
}
</script>

<style scoped="scoped" lang="scss">
/* @import url("./operation.css"); */
@import "./operation_default.scss";
@import "./operation.scss";
</style>


// WEBPACK FOOTER //
// src/components/report/operation_log/operation.vue